import React from 'react';
import { Table } from 'react-bootstrap';

const OvertimeRecordReportFilterDataTable = ({ attendances, attendancesTotal }) => {
  const renderResult = attendance => {
    return (
      <tr>
        <td className="text-center align-middle">{attendance.date_formatted}</td>
        <td className="text-center align-middle">{attendance.shift}</td>
        <td className="text-center align-middle">{attendance.attendance_day}</td>
        <td className="text-center align-middle">{attendance.attendance_break}</td>
        <td className="text-center align-middle">{attendance.extra_hours_begin}</td>
        <td className="text-center align-middle">{attendance.extra_hours_end}</td>
        <td className="text-center align-middle">{attendance.extra_hours_collation}</td>
        <td className="text-center align-middle">{attendance.extra_hours_out_shift}</td>
        <td className="text-center align-middle">{attendance.overtime_begin_journey}</td>
        <td className="text-center align-middle">{attendance.overtime_end_journey}</td>
        <td className="text-center align-middle">{attendance.overtime_without_journey}</td>
      </tr>
    );
  };

  const renderData = () => {
    return (
      <>
        <Table className="custom-data-table" bordered size="sm" style={{ fontWeight: 400 }}>
          <thead className="rdt_TableHeadRow" style={{ backgroundColor: '#EBEBEB', textTransform: 'uppercase' }}>
            <tr className="rdt_TableCol">
              <th className="text-center align-middle">Fecha</th>
              <th className="text-center align-middle">Jornada Ordinaria</th>
              <th className="text-center align-middle">Marcas Reales</th>
              <th className="text-center align-middle">Marcas Reales Por Colacion</th>
              <th className="text-center align-middle">T. Extra Inicio Jornada</th>
              <th className="text-center align-middle">T. Extra Termino Jornada</th>
              <th className="text-center align-middle">T. Extra Colacion</th>
              <th className="text-center align-middle">T. Extra Marcacion Sin Turno</th>
              <th className="text-center align-middle">Autorizadas Inicio Jornada</th>
              <th className="text-center align-middle">Autorizadas Termino Jornada</th>
              <th className="text-center align-middle">Autorizadas Fuera de Turno</th>
            </tr>
          </thead>
          <tbody>{attendances && attendances.map(attendance => renderResult(attendance))}</tbody>
          <tfoot style={{ backgroundColor: '#EBEBEB' }}>
            <tr>
              <td className="text-center align-middle">Total</td>
              <td className="text-center align-middle">{attendancesTotal.parsed_shift_time}</td>
              <td className="text-center align-middle">{attendancesTotal.parsed_attendance_day_time}</td>
              <td className="text-center align-middle">{attendancesTotal.parsed_attendance_break_time}</td>
              <td className="text-center align-middle">{attendancesTotal.total_extra_hours_begin}</td>
              <td className="text-center align-middle">{attendancesTotal.total_extra_hours_end}</td>
              <td className="text-center align-middle">{attendancesTotal.total_extra_hours_collation}</td>
              <td className="text-center align-middle">{attendancesTotal.total_extra_hours_out_shift}</td>
              <td className="text-center align-middle">{attendancesTotal.total_overtime_begin}</td>
              <td className="text-center align-middle">{attendancesTotal.total_overtime_end}</td>
              <td className="text-center align-middle">{attendancesTotal.total_overtime_without_journey}</td>
            </tr>
          </tfoot>
        </Table>
      </>
    );
  };

  return <>{renderData()}</>;
};

export default OvertimeRecordReportFilterDataTable;
